module.exports = __webpack_public_path__ + "static/media/logo-cedepe.ce5e2943.png";